import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

//!----------------To get the topics of the particular class and program-----------------
export const getCommonQuizTopicThunk = createAsyncThunk(
  "commonquiz/get",
  async (data) => {
    let response = await api.get(
      `getMasterTtlQuizTopics/${data.usertype}/student/od/${data.program}/${data.clas}`
    );
    return response.data;
  }
);

//!----------------To get the quiz questions which are made----------------

export const getTeacherAssessmentThunk = createAsyncThunk(
  "commonquiz/getquiz",
  async (data) => {
    let response = await api.get(
      `getMasterTtlQuizQuestions/${data.usertype}/${data.language}/${data.topicId}`
    );
    return response.data;
  }
);

//!-----------------To create quiz in the student assessment page(objective / subjective)------------
export const createTeacherAssessmentThunk = createAsyncThunk(
  "assessment/create",
  async (body) => {
    let response = await api.post("saveMasterTtlQuizQuestions", body);
    return response.data;
  }
);

//!-----------------To update quiz in the student assessment page(objective / subjective)------------
export const updateTeacherAssessmentThunk = createAsyncThunk(
  "assessment/update",
  async (reqbody) => {
    const id = reqbody._id;
    const { _id, ...body } = reqbody; // remove _id from reqbody and create new object called body
    let response = await api.put("updateMasterTtlQuizQuestions/" + id, body);
    return response.data;
  }
);

//!------------------to delete the data in the assessment ------------------------
export const deleteTeacherAssessmentThunk = createAsyncThunk(
  "assessment/delete",
  async (id) => {
    let response = await api.delete("deleteMasterTtlQuizTopic/" + id);
    return response.data;
  }
);
